// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"70891b4c","598":"bda9344d","703":"ff34ff68","787":"42c668ac"}[chunkId] + ".chunk.js";
};